import React from "react";
import { useFormContext } from "react-hook-form";

import {
  CheckboxField,
  DateField,
  ImageField,
  MultipleImageField,
  CSVField,
  NumberField,
  IntegerField,
  SelectField,
  AutocompleteField,
  TextField,
} from "./fields";
import { JsonFormControl } from "./types";
import { IFormField } from "./fields/fieldTypes";

interface IJsonFormField {
  field: JsonFormControl;
  disabled?: boolean;
}

/**
 * Map object to convert a string field.inputType to a React Component.
 */
const FIELD_MAP: { [key: string]: (props: IFormField) => JSX.Element | null } =
  {
    text: TextField,
    string: TextField,
    email: TextField,
    password: TextField,
    number: NumberField,
    integer: IntegerField,
    checkbox: CheckboxField,
    switch: CheckboxField,
    select: SelectField,
    autocomplete: AutocompleteField,
    date: DateField,
    image: ImageField,
    multipleimage: MultipleImageField,
    csv: CSVField,
  };

/**
 * A Form Element used to compose a JsonForm
 * @param {JsonFormControl} field An object describing the contents of a form input.
 * @returns {JSX.Element} Form Field
 */
function JsonFormField({
  field,
  disabled = false,
}: IJsonFormField): JSX.Element {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const fieldType = field.type || field.inputType;
  const FieldComponent = FIELD_MAP[fieldType];
  if (!FieldComponent) {
    console.error(`Invalid field type ${field.inputType}.`);
    return <React.Fragment />;
  }

  return (
    <FieldComponent
      field={field}
      isRequired={!!(field.config && !!field.config.required)}
      register={register}
      disabled={disabled}
      errorMessage={(errors[field.fieldName]?.message || "").toString()}
    />
  );
}

export default JsonFormField;
